import styled from "@emotion/styled";
import { Text } from 'src/components';
import { colors } from "src/theme";

const TagStyle = styled.div((props: { background: string }) => ({
  padding: '2px 8px',
  borderRadius: '4px',
  backgroundColor: props.background,
}));

interface TagProps {
  background?: string;
  textColor?: string;
  value?: React.ReactNode;
  bold?: boolean;
}

export const Tag: React.FC<TagProps> = ({ value, textColor = colors.black, background = colors.background1, bold = false }) => {
  const isString = (v: any): v is string => typeof v === 'string';

  return (
    <TagStyle background={background}>
      {isString(value) ? (
        <Text type='tiny' color={textColor} bold={bold}>{value}</Text>
      ) : (
        value
      )}
    </TagStyle>
  )
};

